import React from 'react';
import Link from 'next/link';
import { PoundSterling, ArrowRight, Info } from 'lucide-react';

export default function GiftAidBanner() {
  return (
    <div className="mb-12 bg-gradient-to-r from-amber-50 to-amber-100 border border-amber-200 rounded-2xl p-8 flex flex-col lg:flex-row items-center gap-6">
      <div className="flex-shrink-0 w-16 h-16 bg-amber-400 rounded-2xl flex items-center justify-center">
        <PoundSterling size={28} className="text-white" />
      </div>
      <div className="flex-1 text-center lg:text-left">
        <h3 className="font-display text-xl font-700 text-amber-900 mb-1">Boost your donation by 25% with Gift Aid</h3>
        <p className="text-amber-700 text-sm leading-relaxed max-w-xl">
          If you're a UK taxpayer, the government will add 25p for every £1 you donate — completely free. A £50 donation becomes £62.50 for the cause. Simply tick the Gift Aid box when you donate.
        </p>
        <div className="flex items-center gap-2 mt-2 justify-center lg:justify-start">
          <Info size={13} className="text-amber-600" />
          <span className="text-xs text-amber-600">You must pay at least as much UK income or capital gains tax as you Gift Aid in the current tax year.</span>
        </div>
      </div>
      <Link
        href="/sign-up-login-screen"
        className="flex-shrink-0 inline-flex items-center gap-2 px-5 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-xl transition-all duration-150 active:scale-95 text-sm"
      >
        Donate with Gift Aid
        <ArrowRight size={16} />
      </Link>
    </div>
  );
}